"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("rect", {
      x: "3.0918",
      y: "2.70215",
      width: "14.4121",
      height: "14.4121",
      stroke: "currentColor",
      strokeWidth: "1.2",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M9.7168 9.71051C10.4028 10.5886 10.5615 11.611 10.5615 11.611C10.5615 11.611 9.60788 11.2097 8.92185 10.3316C8.23582 9.45352 8.07716 8.43116 8.07716 8.43116C8.07716 8.43116 9.03077 8.83244 9.7168 9.71051Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M5.03125 9.71051C5.71728 10.5886 5.87594 11.611 5.87594 11.611C5.87594 11.611 4.92233 11.2097 4.2363 10.3316C3.55028 9.45352 3.39161 8.43116 3.39161 8.43116C3.39161 8.43116 4.34522 8.83244 5.03125 9.71051Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M14.4531 9.71051C15.1392 10.5886 15.2978 11.611 15.2978 11.611C15.2978 11.611 14.3442 11.2097 13.6582 10.3316C12.9722 9.45352 12.8135 8.43116 12.8135 8.43116C12.8135 8.43116 13.7671 8.83244 14.4531 9.71051Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M11.2773 6.90021C10.5913 7.77829 10.4327 8.80065 10.4327 8.80065C10.4327 8.80065 11.3863 8.39937 12.0723 7.52129C12.7583 6.64322 12.917 5.62086 12.917 5.62086C12.917 5.62086 11.9634 6.02214 11.2773 6.90021Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M15.9629 6.90021C15.2769 7.77829 15.1182 8.80065 15.1182 8.80065C15.1182 8.80065 16.0718 8.39937 16.7578 7.52129C17.4439 6.64322 17.6025 5.62086 17.6025 5.62086C17.6025 5.62086 16.6489 6.02214 15.9629 6.90021Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M6.54101 6.90021C5.85499 7.77829 5.69632 8.80065 5.69632 8.80065C5.69632 8.80065 6.64993 8.39937 7.33596 7.52129C8.02199 6.64322 8.18065 5.62086 8.18065 5.62086C8.18065 5.62086 7.22704 6.02214 6.54101 6.90021Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M9.7168 4.08991C10.4028 4.96798 10.5615 5.99035 10.5615 5.99035C10.5615 5.99035 9.60788 5.58907 8.92185 4.71099C8.23582 3.83291 8.07716 2.81055 8.07716 2.81055C8.07716 2.81055 9.03077 3.21183 9.7168 4.08991Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M5.03125 4.08991C5.71728 4.96798 5.87594 5.99035 5.87594 5.99035C5.87594 5.99035 4.92233 5.58907 4.2363 4.71099C3.55028 3.83291 3.39161 2.81055 3.39161 2.81055C3.39161 2.81055 4.34522 3.21183 5.03125 4.08991Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M14.4531 4.08991C15.1392 4.96798 15.2978 5.99035 15.2978 5.99035C15.2978 5.99035 14.3442 5.58907 13.6582 4.71099C12.9722 3.83291 12.8135 2.81055 12.8135 2.81055C12.8135 2.81055 13.7671 3.21183 14.4531 4.08991Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M9.7168 15.3309C10.4028 16.209 10.5615 17.2313 10.5615 17.2313C10.5615 17.2313 9.60788 16.83 8.92185 15.952C8.23582 15.0739 8.07716 14.0515 8.07716 14.0515C8.07716 14.0515 9.03077 14.4528 9.7168 15.3309Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M5.03125 15.3309C5.71728 16.209 5.87594 17.2313 5.87594 17.2313C5.87594 17.2313 4.92233 16.83 4.2363 15.952C3.55028 15.0739 3.39161 14.0515 3.39161 14.0515C3.39161 14.0515 4.34522 14.4528 5.03125 15.3309Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M14.4531 15.3309C15.1392 16.209 15.2978 17.2313 15.2978 17.2313C15.2978 17.2313 14.3442 16.83 13.6582 15.952C12.9722 15.0739 12.8135 14.0515 12.8135 14.0515C12.8135 14.0515 13.7671 14.4528 14.4531 15.3309Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M11.2773 12.5206C10.5913 13.3986 10.4327 14.421 10.4327 14.421C10.4327 14.421 11.3863 14.0197 12.0723 13.1417C12.7583 12.2636 12.917 11.2412 12.917 11.2412C12.917 11.2412 11.9634 11.6425 11.2773 12.5206Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M15.9629 12.5206C15.2769 13.3986 15.1182 14.421 15.1182 14.421C15.1182 14.421 16.0718 14.0197 16.7578 13.1417C17.4439 12.2636 17.6025 11.2412 17.6025 11.2412C17.6025 11.2412 16.6489 11.6425 15.9629 12.5206Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M6.54101 12.5206C5.85499 13.3986 5.69632 14.421 5.69632 14.421C5.69632 14.421 6.64993 14.0197 7.33596 13.1417C8.02199 12.2636 8.18065 11.2412 8.18065 11.2412C8.18065 11.2412 7.22704 11.6425 6.54101 12.5206Z",
      fill: "currentColor"
    })]
  });
};

exports.default = Icon;